<template>
  <v-row>
    <v-col class="col-5 col-md-5 col-sm-12 bold-900">
      {{ $t('repairs.detail.where-repair').toUpperCase() }}
    </v-col>
    <v-col class="col-7 col-md-7 col-sm-12 d-flex flex-column">
      <label class="form-radio">
        <input type="radio" data-cy="dealer-radio" v-model="location.kind" value="DEALER" /><i class="form-icon"></i>
        {{ $t('repairs.detail.honda-dealer') }}
      </label>
      <label class="form-radio">
        <input type="radio" v-model="location.kind" value="SUBAGENT" /><i class="form-icon"></i>
        {{ $t('repairs.detail.subagent') }}
      </label>
      <div class="d-flex flex-column">
        <label class="form-radio">
          <input type="radio" v-model="location.kind" value="OTHER" /><i class="form-icon"></i>
          {{ $t('repairs.detail.other') }}{{ location.kind === 'OTHER' ? ':' : '' }}
        </label>
        <m-textarea
          v-if="location.kind === 'OTHER'"
          id="input-3"
          :placeholder="$t('repairs.detail.no-comments')"
          rows="1"
          v-model="location.description"
          auto-grow
          solo></m-textarea>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      default: () => {
        return {kind: 'DEALER', description: null}
      },
    },
  },
}
</script>
